import store from '@/store'
import { NavigationGuard } from 'vue-router'

const isEmailVerified = () => {
  return store.getters['auth/isEmailVerified']
}

export const emailVerifiedGuard: NavigationGuard = (to, from, next) => {
  if (to.matched.some((record) => record.meta.private)) {
    if (!isEmailVerified()) {
      if (to.name !== 'Verify') {
        next('/verify')
        return
      }
    } else {
      if (to.name === 'Verify') {
        next('/members')
        return
      }
    }
  }
  next()
}
